import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { Environment } from "@/types/Environment";

export class NoindexMarker {
  /**
   * 条件に応じて `<meta name="robots" content="noindex,nofollow">` を挿入するguard関数を返却する。
   *
   * router内の `noindex` の指定が `true` だった場合はあらゆる環境でnoindexとしてマークされる。
   * router内の `noindex` の指定が {@link Environment} のリストだった場合、
   * 実行環境がそのリストに含まれた際にnoindexとしてマークされる。
   *
   * 単純なguardメソッドではなく、関数を返却する高階関数としている理由はvue-router/multiguardが
   * `this` のスコープに干渉してきてインスタンス変数をundefinedにしてしまうため。
   *
   * @param env
   */
  static produceMarker(
    env: Environment
  ): (
    to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => void {
    return (
      to: RouteLocationNormalized,
      _from: RouteLocationNormalized,
      next: NavigationGuardNext
    ): void => {
      const noIndexSpecifier = to.meta?.noindex;
      if (
        noIndexSpecifier &&
        (typeof noIndexSpecifier === "boolean" ||
          noIndexSpecifier.includes(env))
      ) {
        const meta = document.createElement("meta");
        meta.name = "robots";
        meta.content = "noindex, nofollow";
        document.head.appendChild(meta);
      }

      next();
    };
  }
}
